import {useSelector} from '@xstate/react';
import type {ActorRefFrom} from 'xstate';

import {RootMachineContext} from '../machines/rootMachine';
import {bookingMachine} from '../machines/bookingMachine';


export const useBookingMachine = () => {
  const rootActorRef = RootMachineContext.useActorRef();
  const bookingActor = rootActorRef.system.get(
    'bookingMachine',
  ) as ActorRefFrom<typeof bookingMachine>;
  const bookingState = useSelector(bookingActor, (state) => state);
  return {
    bookingActor,
    bookingState,
  };
};
